import { registerSW } from 'virtual:pwa-register';

export type PwaNeedRefreshHandler = () => void;

const needRefreshHandlers = new Set<PwaNeedRefreshHandler>();

export function subscribePwaNeedRefresh(handler: PwaNeedRefreshHandler): () => void {
  needRefreshHandlers.add(handler);
  return () => needRefreshHandlers.delete(handler);
}

let applyUpdate: ((reloadPage?: boolean) => Promise<void>) | undefined;

export function applyPwaUpdate(): void {
  void applyUpdate?.(true);
}

if (import.meta.env.PROD) {
  applyUpdate = registerSW({
    onNeedRefresh() {
      needRefreshHandlers.forEach((handler) => handler());
    },
    onOfflineReady() {
      console.info('[PWA] Recursos estáticos prontos para uso offline');
    },
  });
}
